import React from "react";
import { useSelector, useDispatch } from "react-redux";
import urjayLogo from "./../../src/assets/images/comapnyLogo/urjay.svg";
import nbLogo from "./../../src/assets/images/comapnyLogo/Gmark.png";
import ppLogo from "./../../src/assets/images/comapnyLogo/PPLogo.svg";
import dwellLogo from "./../../src/assets/images/comapnyLogo/dwellLogo.svg";
import grLogo from "./../../src/assets/images/comapnyLogo/Girnaar logo.png";
import telawne1 from "./../../src/assets/images/comapnyLogo/Telawne.png";
import smartSpider from "./../../src/assets/images/comapnyLogo/smartSpider.png";
import Anukool from "./../../src/assets/images/comapnyLogo/Anukool.jpg";
import EnifenTelma from "./../../src/assets/images/comapnyLogo/enifintelma.png";
import Enifen from "./../../src/assets/images/comapnyLogo/enifin.png";
import Dolphin from "./../../src/assets/images/comapnyLogo/dolphin.jpg";
import EcomepPCE from "./../../src/assets/images/comapnyLogo/ecomep.png";
import IndianOilLogo from "./../../src/assets/images/comapnyLogo/IndianOilLogo.png";
import GmarkLogo from "./../../src/assets/images/comapnyLogo/Gmark.png";
import AdvantEdge from "./../../src/assets/images/comapnyLogo/advantEdge.jpg";
import NexusLogo from "./../../src/assets/images/comapnyLogo/nexus.jpg";
import WhiteLogo from "./../../src/assets/images/comapnyLogo/white.png";
import { goBackToAdminView } from "../store/actions";

const Logo = () => {
  const dispatch = useDispatch();
  const account = useSelector((state) => state.account);

  let logoSource = nbLogo;
  let logoStyle = { width: 72, height: 40, objectFit: "contain" };

  // ✅ Hostname-based override
  if (typeof window !== "undefined") {
    const hostname = window.location.hostname;
    const brandConfigs = [
      {
        domains: ["dashboard.nbsense.com", "localhost"],
        logo: nbLogo,
        style: { width: 72, height: 40, objectFit: "contain" },
      },
      {
        domains: ["dashboard.smarterspider.com"],
        logo: smartSpider,
        style: { width: 150, height: 40, objectFit: "contain" },
      },
      {
        domains: ["63gma.pointcloudengg.com"],
        logo: EcomepPCE,
        style: { width: 150, height: 40, objectFit: "contain" },
      },
      {
        domains: ["demo.skillnetlearning.com"],
        logo: WhiteLogo,
        style: { width: 72, height: 40, objectFit: "contain" },
      },
    ];

    const matchedBrand = brandConfigs.find((brand) =>
      brand.domains.includes(hostname)
    );

    if (matchedBrand) {
      logoSource = matchedBrand.logo;
      logoStyle = matchedBrand.style;
    }
  }

  // ✅ Dashboard logo fallback
  if (account.dashboard_logo === 3 && account?.user?._id === 482) {
    logoSource = Anukool;
    logoStyle = { width: 110, height: 45 };
  } else if (account.dashboard_logo === 1) {
    logoSource = urjayLogo;
    logoStyle = { width: 100, height: 50 };
  } else if (account.dashboard_logo === 2) {
    logoSource = ppLogo;
    logoStyle = { width: "100%", height: 35 };
  } else if (account.dashboard_logo === 3) {
    logoSource = dwellLogo;
    logoStyle = { width: 60, height: 50 };
  } else if (account.dashboard_logo === 4) {
    logoSource = grLogo;
    logoStyle = { width: 75, height: 35 };
  } else if (account.dashboard_logo === 5) {
    logoSource = telawne1;
    logoStyle = { width: 200, height: 35 };
  } else if (account.dashboard_logo === 6) {
    logoSource = smartSpider;
    logoStyle = { width: 200, height: 35 };
  } else if (account.dashboard_logo === 7) {
    logoSource = Anukool;
    logoStyle = { width: 200, height: 35 };
  } else if (account.dashboard_logo === 8) {
    logoSource = EnifenTelma;
    logoStyle = { width: 200, height: 35 };
  } else if (account.dashboard_logo === 9) {
    logoSource = Enifen;
    logoStyle = { width: 100, height: 35 };
  } else if (account.dashboard_logo === 10) {
    logoSource = Dolphin;
    logoStyle = { width: 100, height: 40 };
  } else if (account.dashboard_logo === 11) {
    logoSource = IndianOilLogo;
    logoStyle = { width: 40, height: 40 };
  } else if (account.dashboard_logo === 12) {
    logoSource = GmarkLogo;
    logoStyle = { width: 100, height: 40 };
  } else if (account.dashboard_logo === 13) {
    logoSource = AdvantEdge;
    logoStyle = { width: 120, height: 40 };
  } else if (account.dashboard_logo === 14) {
    logoSource = NexusLogo;
    logoStyle = { width: 100, height: 40 };
  }


  const handleClick = () => {
    if (account.admin != null) {
      dispatch(goBackToAdminView());
    }
  };

  return (
    <img
      src={logoSource}
      style={logoStyle}
      rel="preload"
      fetchpriority="high"
      alt="NBSense"
      onClick={handleClick}
    />
  );
};

export default Logo;
